
export default {
  path: "information",
  meta: {
    title: "基础资料"
  },
  name: "information",
  component: () => import("@/components/parent-view"),
  children: [
    {
      path: "project",
      meta: {
        title: "项目管理"
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: "",
          name: "information-project",
          meta: {
            title: "项目列表"
          },
          component: () => import("@/view/v5/information/project/index.vue"),
        },
        {
          path: "detail/:id",
          name: "information-project-detail",
          meta: {
            title: "项目详情",
            isCheck: true
          },
          component: () => import("@/view/v5/information/project/detail.vue")
        },
        {
          path: "edit/:id",
          name: "information-project-edit",
          meta: {
            title: "项目编辑",
            isEdit: true
          },
          component: () => import("@/view/v5/information/project/detail.vue")
        },
        {
          path: "audit/:id",
          name: "information-project-audit",
          meta: {
            title: "项目审核",
            isAudit: true
          },
          component: () => import("@/view/v5/information/project/detail.vue")
        },
        {
          path: "add",
          name: "information-project-add",
          meta: {
            title: "新增项目",
            isAdd: true
          },
          component: () => import("@/view/v5/information/project/detail.vue")
        },
      ]
    },
    {
      path: "",
      meta: {
        title: "客户管理"
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: "customer",
          name: "information-customer",
          meta: {
            title: "客户列表"
          },
          component: () => import("@/view/v5/information/customer/index.vue")
        },
        // {
        //   path: "customer/corporate/index",
        //   name: "information-corporate",
        //   meta: {
        //     title: "企业花名册"
        //   },
        //   component: () => import("@/view/v5/information/customer/corporate/index.vue")
        // },
        {
          path: "customer/add",
          name: "information-customer",
          meta: {
            title: "新增客户"
          },
          component: () => import("@/view/v5/information/customer/detail.vue")
        },
        {
          path: "customer/edit/:id",
          name: "information-customer",
          meta: {
            title: "编辑客户"
          },
          component: () => import("@/view/v5/information/customer/detail.vue")
        },
        {
          path: "customer/detail/:id",
          name: "information-customer",
          meta: {
            title: "客户详情"
          },
          component: () => import("@/view/v5/information/customer/detail.vue")
        },
        {
          path: "customer/audit/:id",
          name: "information-customer",
          meta: {
            title: "客户审批"
          },
          component: () => import("@/view/v5/information/customer/detail.vue")
        },
      ]
    },
    // {
    //   path: "invioce/ticket/:orgId",
    //   name: "invoice-detail",
    //   meta: {
    //     title: "增票资质"
    //   },
    //   component: () => import("@/view/v5/information/customer/invioce/ticket.vue")
    // },
    // {
    //   path: "invioce/:purchaseId",
    //   name: "invoice-detail",
    //   meta: {
    //     title: "增票机制"
    //   },
    //   component: () => import("@/view/v5/information/customer/invioce/invoice.vue")
    // },
    {
      path: 'supplier',
      meta: {
        title: '供应商管理'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: '',
          meta: {
            title: '供应商列表',
            ignoreBreadCrumb: true
          },
          name: 'information-supplier-list',
          component: () => import('@/view/v5/information/supplier/supplier-manage.vue')
        },
        {
          path: 'add',
          name: 'information-supplier-add',
          meta: {
            title: '新增供应商'
          },
          component: () => import('@/view/v5/information/supplier/edit.vue')
        },
        {
          path: 'edit',
          name: 'information-supplier-edit',
          meta: {
            hideInTabBar: true,
            title: '编辑供应商'
          },
          component: () => import('@/view/v5/information/supplier/edit.vue')
        },
        {
          path: 'detail/:id',
          name: 'information-supplier-detail',
          meta: {
            hideInTabBar: true,
            title: '供应商详情'
          },
          component: () => import('@/view/v5/information/supplier/detail.vue')
        },
        {
          path: 'audit/:id',
          name: 'information-supplier-audit',
          meta: {
            hideInTabBar: true,
            title: '审核供应商'
          },
          component: () => import('@/view/v5/information/supplier/detail.vue')
        }
      ]
    },
  ]
};


// WEBPACK FOOTER //
// ./src/router/routes/v5/information.js